import React from 'react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { cn } from '@/lib/utils';
import { notAvailableYetHint } from '@/lib/notAvailableYet';

// Placeholder for FIG-316 UI whose data or logic the backend does not support
// yet. It never shows fake data; the tooltip names the backend use case that
// unblocks it (see .foundry/spec/fig-316/use-cases/).

interface NotAvailableYetProps {
  /** Backend use case that unblocks this piece, e.g. "UC-217". */
  useCase: string;
  /** Visible text. Defaults to "Not available yet". */
  label?: string;
  className?: string;
}

export const NotAvailableYet: React.FC<NotAvailableYetProps> = ({ useCase, label = 'Not available yet', className }) => (
  <TooltipProvider>
    <Tooltip>
      <TooltipTrigger asChild>
        <span
          tabIndex={0}
          className={cn('cursor-help text-sm text-muted-foreground', className)}
          aria-label={notAvailableYetHint(useCase)}
        >
          {label}
        </span>
      </TooltipTrigger>
      <TooltipContent>
        <p>{notAvailableYetHint(useCase)}</p>
      </TooltipContent>
    </Tooltip>
  </TooltipProvider>
);

export default NotAvailableYet;
